module.exports = __webpack_public_path__ + "media/tenant-placement-hero-image-mobile.7ae73453.svg";